import adtAlertsIcon from "@/assets/svg/adtAlerts.svg";
import adtAlertsDarkIcon from "@/assets/svg/adtAlertsDarkIcon.svg";
import riskStratIcon from "@/assets/icons/risk-stratification.svg";
import careGapsIcon from "@/assets/svg/careGapsLightIcon.svg";
import careGapsDarkIcon from "@/assets/svg/careGapsDarkIcon.svg";
import behavioralIcon from "@/assets/icons/behavioralIconDark.svg";
import behavioralIconDark from "@/assets/icons/behavioralIconLight.svg";
import medicalIcon from "@/assets/icons/medicalDiagnoses.svg";
import sdohIcon from "@/assets/icons/sdohIconLight.svg";
import sdohIconDark from "@/assets/icons/sdohIconDark.svg";
import recentVisitsIcon from "@/assets/icons/recent-visits.svg";
import costUtilIcon from "@/assets/icons/costUtilizationIconLight.svg";
import costUtilIconDark from "@/assets/icons/costUtilizationIconDark.svg";
import medicationIcon from "@/assets/svg/medicationFillHistoryLightIcon.svg";
import medicationIconDark from "@/assets/svg/medicationFillHistoryDarkIcon.svg";
import immunizationsIcon from "@/assets/icons/immuniztionLight.svg";
import immunizationsIconDark from "@/assets/icons/immunizationDark.svg";
import referralsIcon from "@/assets/svg/referralsLightIcon.svg";
import referralsIconDark from "@/assets/svg/referralsDarkIcon.svg";
import pcpIcon from "@/assets/icons/pcp.svg";
import healthPlanIcon from "@/assets/icons/healthplan.svg";

export interface CardConfig {
  id: string;
  icon: { light: string; dark: string };
}

export const CARD_REGISTRY: Record<string, CardConfig> = {
  ADT_ALERTS: {
    id: "ADT_ALERTS",
    icon: { light: adtAlertsIcon, dark: adtAlertsDarkIcon },
  },
  RISK_STRATIFICATION: {
    id: "RISK_STRATIFICATION",
    icon: { light: riskStratIcon, dark: riskStratIcon },
  },
  CARE_GAPS: {
    id: "CARE_GAPS",
    icon: { light: careGapsIcon, dark: careGapsDarkIcon },
  },
  BEHAVIORAL_HEALTH_DIAGNOSES: {
    id: "BEHAVIORAL_HEALTH_DIAGNOSES",
    icon: { light: behavioralIcon, dark: behavioralIconDark },
  },
  MEDICAL_DIAGNOSES: {
    id: "MEDICAL_DIAGNOSES",
    icon: { light: medicalIcon, dark: medicalIcon },
  },
  SDOH_BARRIERS: {
    id: "SDOH_BARRIERS",
    icon: { light: sdohIcon, dark: sdohIconDark },
  },
  RECENT_VISITS_ENCOUNTERS: {
    id: "RECENT_VISITS_ENCOUNTERS",
    icon: { light: recentVisitsIcon, dark: recentVisitsIcon },
  },
  TWELVE_MONTH_COST_UTILIZATION: {
    id: "TWELVE_MONTH_COST_UTILIZATION",
    icon: { light: costUtilIcon, dark: costUtilIconDark },
  },
  MEDICATION_FILL_HISTORY: {
    id: "MEDICATION_FILL_HISTORY",
    icon: { light: medicationIcon, dark: medicationIconDark },
  },
  IMMUNIZATIONS: {
    id: "IMMUNIZATIONS",
    icon: { light: immunizationsIcon, dark: immunizationsIconDark },
  },
  REFERRALS: {
    id: "REFERRALS",
    icon: { light: referralsIcon, dark: referralsIconDark },
  },
  PCP: {
    id: "PCP",
    icon: { light: pcpIcon, dark: pcpIcon },
  },
  HEALTH_PLAN: {
    id: "HEALTH_PLAN",
    icon: { light: healthPlanIcon, dark: healthPlanIcon },
  },
};

export const NORMALIZATION_MAP: Record<string, string> = {
  "ADT Alerts": "ADT_ALERTS",
  "Risk Stratification": "RISK_STRATIFICATION",
  "Care Gaps": "CARE_GAPS",
  "Behavioral Health Diagnoses": "BEHAVIORAL_HEALTH_DIAGNOSES",
  "Medical Diagnoses": "MEDICAL_DIAGNOSES",
  "Health Related Social Needs": "SDOH_BARRIERS",
  "Recent Visits / Encounters": "RECENT_VISITS_ENCOUNTERS",
  "12-month Cost/Utilization": "TWELVE_MONTH_COST_UTILIZATION",
  "12-month Cost / Utilization": "TWELVE_MONTH_COST_UTILIZATION",
  "Medication Fill History": "MEDICATION_FILL_HISTORY",
  "Immunizations": "IMMUNIZATIONS",
  "Referrals": "REFERRALS",
  "Primary Care Provider": "PCP",
  "PCP": "PCP",
  "Primary Care Provider (PCP)": "PCP",
  "Health Plan": "HEALTH_PLAN",
};

export const Card_Alt_Titles = NORMALIZATION_MAP;
export const CARD_ICONS = Object.fromEntries(Object.values(CARD_REGISTRY).map(c => [c.id, c.icon]));
